module.exports = __webpack_public_path__ + "img/libros-cont.5efcb75f.png";